(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/route-result.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/route-result.js');
"use strict";

const _React = React,
  useContext = _React.useContext;
const OverviewHero = svs.components.marketplaceCompetition.overviewHero.OverviewHero;
const CompetitionMenuContext = svs.components.marketplaceCompetition.competitionMenu.CompetitionMenuContext;
const Highscore = svs.components.marketplaceCompetition.routeResult.highscore.Highscore;
const RouteResult = () => {
  const _useContext = useContext(CompetitionMenuContext),
    competitionMenu = _useContext.competitionMenu;
  return React.createElement(React.Fragment, null, React.createElement(OverviewHero, null), React.createElement("span", {
    className: "competition-overflow-up"
  }, competitionMenu), React.createElement(Highscore, null));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.RouteResult', RouteResult);

 })(window);